import React, { useState } from 'react';
import styled from 'styled-components';
import { Tab } from 'rbx';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { isNull } from 'lodash';
import Details from './Details';
import ReviewPhotos from './ReviewPhotos';
import ReviewFlags from './ReviewFlags';
import ReviewComments from './ReviewComments';
import ReviewLikes from './ItemReviewLikes';
import SocialCounts from './SocialCounts';

import { Box, Tabs } from '../../../components/elements';

import Header from './Header';
import Footer from './Footer';

const Container = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
`;
const tabs = [
  {
    key: 0,
    name: 'Item Review Detail',
  },
  {
    key: 1,
    name: 'Review Photos',
  },
];

const Form = props => {
  const [activeTab, setActiveTab] = useState(0);
  const {
    handleSubmit,
    loading,
    values,
    action,
    handleAction,
    place,
    review,
    images,
    dirty,
    updateItemReviewLoading,
  } = props;

  const prev = () =>
    activeTab === 0 ? setActiveTab(4) : setActiveTab(activeTab - 1);

  const next = () =>
    activeTab === 4 ? setActiveTab(0) : setActiveTab(activeTab + 1);

  const handleApprovedAction = async () => {
    await handleAction('APPROVED');
    handleSubmit();
  };
  const handleRejectAction = async () => {
    await handleAction('REJECTED');
    handleSubmit();
  };
  const handleUpdateReview = async () => {
    await handleAction('ITEM_UPDATE');
    handleSubmit();
  };
  return (
    <React.Fragment>
      <Header
        heading="Item Review Approval"
        prev={prev}
        next={next}
        dirty={dirty}
        loading={loading}
        activeTab={activeTab}
        action={action}
        status={values.status}
        itemName={values.item_name}
        updateItemReviewLoading={updateItemReviewLoading}
        handleUpdateReview={handleUpdateReview}
        handleApprovedAction={handleApprovedAction}
        handleRejectAction={handleRejectAction}
        placeListingStatus={place.listing_status}
        // eslint-disable-next-line max-len
        subHeading={`${place.name} | ${place.city}, ${place.post_code} | ${place.country} (${place.status} / ${place.claim_status} / ${review.status})`}
      />
      <Box>
        <Tabs className="tabs is-medium">
          {tabs.map(tab => (
            <Tab
              active={activeTab === tab.key}
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.name}
            </Tab>
          ))}
          {review.status !== 'SUBMITTED' && (
            <Tab active={activeTab === 2} onClick={() => setActiveTab(2)}>
              Review Likes
            </Tab>
          )}
          {review.status !== 'SUBMITTED' && (
            <Tab active={activeTab === 3} onClick={() => setActiveTab(3)}>
              Review Comments
            </Tab>
          )}
          {review.status !== 'SUBMITTED' && (
            <Tab active={activeTab === 4} onClick={() => setActiveTab(4)}>
              Review Flags
            </Tab>
          )}
        </Tabs>

        <Container>
          <div style={{ marginTop: '0.2rem' }}>
            {place.listing_status !== 'APPROVED' && (
              <p style={{ color: '#FFC841', fontWeight: '600' }}>
                Place listing is not approved. Place listing must be reviewed
                and approved before, then the item listing can be approved.
              </p>
            )}
          </div>
          <div style={{ marginTop: '0.5rem' }}>
            <SocialCounts {...props} />
          </div>

          {activeTab === 0 && <Details {...props} images={images} />}
          {activeTab === 1 && (
            <ReviewPhotos
              reviewStatus={values.status}
              images={values.images}
              setFieldValue={props.setFieldValue}
            />
          )}

          {review.status !== 'SUBMITTED' && (
            <React.Fragment>
              {activeTab === 2 && <ReviewLikes {...props} />}
              {activeTab === 3 && <ReviewComments {...props} reivew={review} />}
              {activeTab === 4 && <ReviewFlags {...props} />}
            </React.Fragment>
          )}
        </Container>
      </Box>
      <hr />

      <Footer
        prev={prev}
        next={next}
        dirty={dirty}
        action={action}
        activeTab={activeTab}
        loading={loading}
        placeListingStatus={place.listing_status}
        status={values.status}
        handleUpdateReview={handleUpdateReview}
        updateItemReviewLoading={updateItemReviewLoading}
        handleApprovedAction={handleApprovedAction}
        handleRejectAction={handleRejectAction}
      />
    </React.Fragment>
  );
};

const ItemReviewForm = withFormik({
  mapPropsToValues: ({ review, images }) => ({
    place_id: review && !isNull(review.place_id) ? review.place_id : '',
    item_id: review && !isNull(review.item_id) ? review.item_id : '',
    item_name: review && !isNull(review.item.name) ? review.item.name : '',
    status: review && !isNull(review.status) ? review.status : '',
    cuisine_style:
      review && !isNull(review.cuisine_style) ? review.cuisine_style : '',
    item_type: review && !isNull(review.item_type) ? review.item_type : [],
    rating: review && !isNull(review.rating) ? review.rating : 0,
    content: review && !isNull(review.content) ? review.content : '',
    user_info: review && !isNull(review.user_info) ? review.user_info : {},
    image: review && !isNull(review.image) ? review.image : [],
    note: '',
    images: images.length !== 0 ? images : [],
  }),

  validationSchema: yup.object().shape({
    note: yup.string().required('Note is Required!'),
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    setTimeout(() => {
      props.onSubmit(values);
      setSubmitting(false);
    }, 300);
  },

  displayName: 'ItemReviewForm',
})(Form);

export default ItemReviewForm;
